import React, { Fragment } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css'
import Home from "./componts/Home/Home.js";
import Fany from "./componts/Fany/Fany.js";
import Servises from "./componts/Servises/Servises.js";
import NavBar1 from "./componts/NavBar/NavBar.js";
import Footer from "./componts/Footer/Footer.js";


function App() {
  return(
    <Fragment>
     <BrowserRouter>
       <NavBar1/>
         <Routes>
           <Route path="/" element={<Home/>}/>
           <Route path='/الخدمات' element={<Servises/>}/>
           <Route path="/فني" element={<Fany/>}/>
         </Routes>
         <Footer/>
     </BrowserRouter>
     
      
    </Fragment>
  )  
}

export default App;
